import { Injectable } from '@angular/core';
import { FormBuilder, FormControl, Validators, FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { ReclamacaoVO } from '../../entity/ReclamacaoVO';
import { RestService } from '../rest.service';
import { AuthService } from '../autenticacao/auth.service';
import { URL_API } from 'src/app/tools/URL';
import { MSG_OBG_ASSUNTO, MSG_OBG_CLASSIFICACAO, MSG_OBG_MUNICIPIO, MSG_OBG_CARTORIO, MSG_OBG_DESCRICAO, MSG_LIMITE_DESCRICAO, MSG_OBG_TIPO_JUSTICA, MSG_OBG_TIPO_JUSTICA_OPCAO, MSG_OBG_NUM_PROCESSO, MSG_OBG_NUM_PROCESSO_VALIDO, MSG_OBG_TIPO_JUSTICA_OPCAO_ANEXO, MSG_RECLAMACAO_OBG_COMARCA, OK_PROTOCOLO_MANIFESTACAO, ERRO_DADOS_NAO_GRAVADOS } from 'src/app/tools/Mensagens';
import { CARREGAR, ErrorsService } from '../errors/errors.service';
import { catchError } from 'rxjs/internal/operators/catchError';
import { HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ReclamacaoService {

  reclamacao = this.builder.group(this.preencherVo());

  CLASSIFICACAO_SERVIDOR_INTERIOR = 39;

  constructor(private rest: RestService, private builder: FormBuilder, private authService: AuthService, private errorsService: ErrorsService) {}

  salvarReclamacao(reclamacao): Observable<any> {
    return this.rest.post(`${URL_API.PATH_RECLAMACAO}`, this.prepararPayload(reclamacao));
  }

  private prepararPayload(reclamacao) {
    return reclamacao.assunto && reclamacao.assunto.value === 'reclamacao_admin_violencia_genero'
      ? reclamacao : { ...reclamacao, reclamacaoViolencia: null };
  }

  salvar(obj) {
    if (obj.id == null) {
      return this.gravar(obj);
    } else {
      return this.atualizar(obj);
    }
  }

  enviar(obj) {
    return this.rest.post(`${URL_API.PATH_RECLAMACAO}/enviar`, this.prepararPayload(obj));
  }

  gravar(obj) {
    return this.rest.post(`${URL_API.PATH_RECLAMACAO}/salvar`, this.prepararPayload(obj));
  }

  atualizar(obj: ReclamacaoVO) {
    return this.rest.put(`${URL_API.PATH_RECLAMACAO}/salvar/${obj.id}`, this.prepararPayload(obj));
  }

  buscarCartoriosPorCodMunicipioCodComarca(codigoMunicipio : any, codigoComarca: any){
    return this.rest.get(`${URL_API.PATH_DENUNCIA}/buscarCartoriosCodMunicipioCodComarca/` + codigoMunicipio + '/' + codigoComarca);
  }

  carregarDados() {

    this.rest.get(`${URL_API.PATH_RECLAMACAO}/carregar`).subscribe(retorno => {
      this.reclamacao.controls.listaClassificacaoCompleta.setValue(retorno.listaClassificacaoCompleta);
      this.reclamacao.controls.listaCartorio.setValue(retorno.listaCartorio);
      this.reclamacao.controls.listaTipoProcessoCompleta.setValue(retorno.listaTipoProcessoCompleta);
      this.reclamacao.controls.listaSistemasCompleta.setValue(retorno.listaSistemasCompleta);
      this.reclamacao.controls.listaUnidade.setValue(retorno.listaUnidade);
      this.reclamacao.controls.assuntos.setValue(retorno.assuntos);

      this.reclamacao.controls.listaMunicipio.setValue(retorno.listaMunicipio);
      this.reclamacao.controls.listaComarcas.setValue(retorno.listaComarcas);
      this.reclamacao.controls.listaTipoViolencia.setValue(retorno.listaTipoViolencia || []);
      this.reclamacao.controls.listaCorRaca.setValue(retorno.listaCorRaca || []);

    });

  }

  carregarPorId(id: number) {

    return this.rest.get(`${URL_API.PATH_RECLAMACAO + '/' + id}`);

  }

  gravarManifestoOperador(manifestante, arquivos = [], isEnviar, arquivosCunhoDisciplinar?) {

    this.reclamacao.controls.nome.setValue(manifestante.nome);
    this.reclamacao.controls.email.setValue(manifestante.email);
    this.reclamacao.controls.username.setValue(this.authService.usuarioLogado.username);

    if (this.reclamacao.value.tipoDeJustica !== '1' && this.reclamacao.value.tipoDeJustica !== '2') {

      this.reclamacao.value.tipoDeJustica = null;
      this.reclamacao.value.opcaoTipoDeJustica = null;

    }

    this.reclamacao.controls.files.setValue([]);
    arquivos.forEach((value, key) => {
      this.reclamacao.value.files.push({
        nomeArquivo: key,
        conteudo: value
      });
    });

    // Preenchimento dos arquivos anexos para quando for 1ª Instância - Reclamação de cunho disciplinar, caso existirem
    if(arquivosCunhoDisciplinar != null && arquivosCunhoDisciplinar != []){
      this.reclamacao.controls.filesCunhoDisciplinar.setValue([]);
      //console.log('Arquivos anexados teste -> ', arquivos);
      arquivosCunhoDisciplinar.forEach((value, key) => {
        var nomeArquivoComTag = String(key).replace("."," (RGCE).");
        this.reclamacao.value.filesCunhoDisciplinar.push({
          nomeArquivo: nomeArquivoComTag,
          conteudo: value
        });
      });
    }

    return isEnviar ? this.enviar(this.reclamacao.getRawValue()) : this.salvar(this.reclamacao.getRawValue());

  }

  buscarProcesso() {

    const numeroProcesso = this.reclamacao.value.numeroProcesso.replace('-', '').split('.').join('');

    return this.rest.get(`${URL_API.PATH_RECLAMACAO}/processo/buscar`, {
      numeroProcesso,
      tipoJustica: this.reclamacao.value.tipoDeJustica.toString()
    });

  }

  preencherVo() {

    return {
      id: null,
      username: new FormControl(null),
      dataHoraAbertura: null,
      nome: new FormControl(null),
      email: new FormControl(null),
      tipoDeJustica: new FormControl(null),
      opcaoTipoDeJustica: new FormControl(null),
      numeroProcesso: new FormControl({ value: null, disabled: true }),
      comarca: new FormControl({ value: null, disabled: true }),
      vara: new FormControl({ value: null, disabled: true }),
      codUnidade: new FormControl(null),
      siglaUnidade: new FormControl(null),
      numeroINFOPEN: new FormControl(null),
      descricaoReclamacao: new FormControl({ value: null }, [Validators.required, Validators.maxLength(5000)]),
      listaCartorio: [],
      municipio: new FormControl({ value: null, disabled: false }),
      cartorio: new FormControl({ value: null, disabled: true }),
      listaTipoProcesso: new FormControl([]),
      listaTipoProcessoCompleta: [],
      listaSistemas: new FormControl([]),
      listaSistemasCompleta: [],
      listaClassificacao: new FormControl([]),
      listaClassificacaoCompleta: [],
      listaUnidade: [],
      unidadeAux: new FormControl(null),
      assunto: new FormControl(null, [Validators.required]),
      assuntos: [],
      files: null,
      filesCunhoDisciplinar: null,
      listaMunicipio: [],
      listaComarcas:[],
      codigoMunicipio: null,
      codigoComarca: null,
      codigoCNS: null,
      nomeServentia: null,
      localidade: null,
      demandaRecebida: new FormControl(null),
      listaTipoViolencia: [],
      listaCorRaca: [],
      reclamacaoViolencia: this.builder.group({
        id: null,
        processoAndamento: null,
        exercicioFuncao: null,
        fatoDependenciaOrgao: null,
        riscoAtual: null,
        denunciaOutroCanal: null,
        desejaAudienciaPrevia: null,
        inobservanciaProtocolo: null,
        declaracaoVeracidade: false,
        autorizaCompartilhamento: null,
        numeroProcesso: null,
        dataFatos: null,
        outroCanal: null,
        vitima: this.builder.group({
          id: null, cpf: null, possuiDeficiencia: null, dataNascimento: null,
          corRaca: null, rua: null, bairro: null, complemento: null,
          cidade: null, estado: null, cep: null, telefone: null, emailComunicacao: null
        }),
        agressor: this.builder.group({
          id: null, agressorConhecido: true, nomeAgressor: null,
          cargoAgressor: null, orgaoAgressor: null
        }),
        tipos: [[]],
        provas: [[]]
      })

    } as ReclamacaoVO;

  }


  // TODO Verificar se os métodos continuarão no service ou irão para uma classe de validação especifica.
  isReclamacaoTipoDeJusticaPrimeiraInstancia(reclamacao: FormGroup) {
    if (reclamacao.value.assunto.value === 'reclamacao_processo'
      && reclamacao.value.tipoDeJustica != null
      && reclamacao.value.tipoDeJustica === '1') {

      return true;
    }

    return false;
  }

  validaCamposReclamacaoService(reclamacao: FormGroup) {
    var mensagensErro = '';

    if (reclamacao.value.assunto == null || reclamacao.value.assunto === '') {
      mensagensErro = mensagensErro + MSG_OBG_ASSUNTO;
    } else {
      // Validação de classificações não deverá ser feita caso seja Processos Judiciais de 1ª Instância
      if (reclamacao.value.assunto.value !== 'reclamacao_admin_violencia_genero'
        && !this.isReclamacaoTipoDeJusticaPrimeiraInstancia(reclamacao)
        && reclamacao.value.listaClassificacao.length === 0) {
        mensagensErro = mensagensErro + MSG_OBG_CLASSIFICACAO;
      }

       // Substituição dos campos de municio e cartorio (OS 1285)
      if (reclamacao.value.codigoMunicipio === '' && reclamacao.value.assunto.value === 'reclamacao_cartorios') {
        mensagensErro = mensagensErro + MSG_OBG_MUNICIPIO;
        reclamacao.controls['codigoMunicipio'].setErrors({});
      }

      if (reclamacao.value.codigoCNS === '') {
        reclamacao.controls['codigoCNS'].setErrors({});
        mensagensErro = mensagensErro + MSG_OBG_CARTORIO;
      }

      if (reclamacao.value.descricaoReclamacao === ''
        || reclamacao.value.descricaoReclamacao == null) {
        mensagensErro = mensagensErro + MSG_OBG_DESCRICAO;
      } else if (reclamacao.value.descricaoReclamacao.length < 0
        && reclamacao.value.descricaoReclamacao.length > 5000) {
        mensagensErro = mensagensErro + MSG_LIMITE_DESCRICAO;
      }
      if (reclamacao.value.assunto.value === 'reclamacao_processo') {
        // Tratamento para as opções do tipo de justiça quando for 1ª Instância
        if (reclamacao.value.tipoDeJustica === ''
          || reclamacao.value.tipoDeJustica == null) {
          mensagensErro = mensagensErro + MSG_OBG_TIPO_JUSTICA;
          reclamacao.controls['tipoDeJustica'].setErrors({});

        } else if (reclamacao.value.tipoDeJustica === '1') {
          if (reclamacao.value.opcaoTipoDeJustica === null) {
            reclamacao.controls['opcaoTipoDeJustica'].setErrors({});
            mensagensErro = mensagensErro + MSG_OBG_TIPO_JUSTICA_OPCAO;
          }
        }
        // Regras dos campos do processo
        if (reclamacao.value.numeroProcesso === '') {
          reclamacao.controls['numeroProcesso'].setErrors({});
          mensagensErro = mensagensErro + MSG_OBG_NUM_PROCESSO;
        } else if (reclamacao.controls.comarca.value === '' || reclamacao.controls.comarca.value === null) {
          reclamacao.controls['comarca'].setErrors({});
          mensagensErro = mensagensErro + MSG_OBG_NUM_PROCESSO_VALIDO;
        } else if (reclamacao.controls.vara.value === '' || reclamacao.controls.vara.value === null) {
          reclamacao.controls['vara'].setErrors({});
          mensagensErro = mensagensErro + MSG_OBG_NUM_PROCESSO_VALIDO;
        }
      }

      if (reclamacao.value.assunto.value === 'reclamacao_natureza') {

        if (reclamacao.value.listaClassificacao.length > 0) {
        var idClassificacao = reclamacao.value.listaClassificacao[0].id;
        // Campos de Servidor Interior
        if (idClassificacao === this.CLASSIFICACAO_SERVIDOR_INTERIOR) {

          if (reclamacao.value.codigoComarca == null || reclamacao.value.codigoComarca == '') {
            mensagensErro = mensagensErro + MSG_RECLAMACAO_OBG_COMARCA;
          }
        }
       }
      }

    }

    return mensagensErro;
  }

  // Método que valida as regras, caso seja selecioonado o tipo de justiça 1ª Instância. (OS 860)
  // Observação: Necessitou ficar separada das outras validações de campos pois era necessário o popular da lista de documentos
  // que só seria feito depois de executar o validarFormulario
  validarRegrasPrimeiraInstânciaService(reclamacao: FormGroup, arquivosCunhoDisciplinar: any[]) {
    //TODO - Revisar a solução pois, não é a melhor
    var quantidadeAnexos = 0;
    arquivosCunhoDisciplinar.forEach(() => { quantidadeAnexos++ });
    //console.log('Quantidade de arquivos -> ', quantidadeAnexos);
    var mensagemErro = '';
    if (reclamacao.value.tipoDeJustica === '1') {
      if (reclamacao.value.opcaoTipoDeJustica == '2'
        && (quantidadeAnexos === 0)) {
        mensagemErro = MSG_OBG_TIPO_JUSTICA_OPCAO_ANEXO;
      }
    }

    return mensagemErro;
  }

  handleError(error: HttpErrorResponse) {

    console.log(error);
    window.alert(ERRO_DADOS_NAO_GRAVADOS);
    return throwError(ERRO_DADOS_NAO_GRAVADOS);

  }


}
